<template>
  <v-container v-if="session.isStudent() && session.getStudentColleges().length>0">
    <v-row>
        <v-col>
          <h1>{{ $t('selectcollegeDesc') }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-for="profile in session.getStudentColleges()" :key="profile.CollegeName+''+profile.SectionName">
            <v-card tile elevation="2" class="profile-card-item pa-2 text-start" :class="{ selected: isSelected(profile) }"
            @click="changeCollege(profile)"
            >
                <v-row>
                    <v-col>
                        {{ $t('college') }}
                    </v-col>
                    <v-col>
                        {{ profile.CollegeName }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        {{ $t('section') }}
                    </v-col>
                    <v-col>
                        {{ profile.SectionName }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        {{ $t('series') }}
                    </v-col>
                    <v-col>
                        {{ profile.SeriesName }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        {{ $t('yearOfstudy') }}
                    </v-col>
                    <v-col>
                        {{ profile.Year }}
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
    
  </v-container>  
</template>

<script>

import { session } from '@/js/session';
import apiController from '@/js/apiController';

export default {
  name: 'SelectCollege',
  props: {
    showSelected: {
      type: Boolean,
      default: true
    }
    },
  data() {
    return { session, apiController }
  },
  async mounted() {
  },
  methods: {
    isSelected(profile){
      if(this.showSelected) {
        return profile.CollegeName == this.$localStorage.get('collegeName') 
        && profile.SectionName == this.$localStorage.get('sectionName') 
        && profile.SeriesName == this.$localStorage.get('seriesName') 
        && profile.Year == this.$localStorage.get('year') 
      }
    },
    async changeCollege(profile){
      if(!this.isSelected(profile)){
        const res = await this.apiController.get("login/changeContext",{collegeId: profile.PkCollege, sectionId:profile.PkSection});
        this.session.setupLogin(res.data);
        location.reload();
      }
    }
  }
}
</script>
<style scoped>
.selected {
  background: #c3ebc3;
}
.not-selected {
  cursor: pointer;
}
</style>
